class SearchDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('#SearchDrawer-Overlay');
    this.inner = this.querySelector('.search-drawer__inner');
    this.closeButton = this.querySelector('.search-drawer__close');
    this.input = this.querySelector('.search__input');
    this.form = this.querySelector('form.search');

    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    if (this.overlay) this.overlay.addEventListener('click', this.close.bind(this));
    if (this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));

    this.bindTriggers();
    this.bindSearchState();
  }

  bindTriggers() {
    document.querySelectorAll('.search-drawer-trigger').forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(trigger);
      });
    });
  }

  bindSearchState() {
    if (!this.input) return;
    const updateState = () => {
      this.classList.toggle('is-searching', this.input.value.trim().length > 0);
    };
    this.input.addEventListener('input', updateState);
    this.input.addEventListener('search', updateState);
    // Reinicia o estado quando o formulário é limpo (botão reset)
    if (this.form) {
      this.form.addEventListener('reset', () => {
        setTimeout(() => this.classList.remove('is-searching'), 0);
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;

    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    this.inner.addEventListener(
      'transitionend',
      () => {
        if (typeof trapFocus === 'function') {
          trapFocus(this.inner, this.input || this.inner);
        } else if (this.input) {
          this.input.focus();
        }
      },
      { once: true }
    );

    // Fallback caso o input precise de foco imediato (mobile teclado)
    setTimeout(() => {
      if (this.input) this.input.focus({ preventScroll: true });
    }, 320);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    } else if (this.activeElement && this.activeElement.focus) {
      this.activeElement.focus();
    }
  }
}

customElements.define('search-drawer', SearchDrawer);
